module.exports = __webpack_public_path__ + "img/paciente_mujer.e72ecd0d.svg";